import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { DataLine, H2 } from "commons";

export function ContactDetails({ homePhone, mobilePhone, businessPhone }) {
    const getCssClass = () => {
        return homePhone || mobilePhone || businessPhone ? null : "large-only";
    };

    return (
        <div data-testid="contact-details" className={getCssClass()}>
            <H2 secondary textAlign="center">
                Contact details
            </H2>
            <Fields>
                <DataLine name="Home" value={homePhone} />
                <DataLine name="Mobile" value={mobilePhone} />
                <DataLine name="Work" value={businessPhone} />
            </Fields>
        </div>
    );
}

const Fields = styled.div`
    background: ${props => props.theme.tertiary};
    padding: 1.5em;
`;

ContactDetails.propTypes = {
    homePhone: PropTypes.string,
    mobilePhone: PropTypes.string,
    businessPhone: PropTypes.string
};
